export default {
  root: {
    borderRadius: '8px',
    backgroundColor: '#ffffff',
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: '#FF9800'
    },
    '&.Mui-disabled': {
      backgroundColor: '#f5f5f5'
    }
  },
  notchedOutline: {
    borderColor: 'rgba(0,0,0,0.15)'
  },
  input: {
    '&.Mui-disabled': {
      WebkitTextFillColor: 'rgba(0, 0, 0, 0.75)',
      color: 'rgba(0, 0, 0, 0.75)'
    }
  }
};
